"use client";

import { useLanguage } from "@/contexts/language-context";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
      <button
        onClick={() => setLanguage("ko")}
        className={`px-2 py-1 text-xs font-bold rounded-md transition-all ${
          language === "ko"
            ? "bg-white dark:bg-gray-600 text-blue-600 dark:text-white shadow-sm"
            : "text-gray-500 hover:text-gray-900 dark:hover:text-gray-300"
        }`}
      >
        KO
      </button>
      <button
        onClick={() => setLanguage("en")}
        className={`px-2 py-1 text-xs font-bold rounded-md transition-all ${
          language === "en"
            ? "bg-white dark:bg-gray-600 text-blue-600 dark:text-white shadow-sm"
            : "text-gray-500 hover:text-gray-900 dark:hover:text-gray-300"
        }`}
      >
        EN
      </button>
    </div>
  );
}
